export default "__VITE_ASSET__tYN$HRbC__"